exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7aee8cd2] .icon-wrapper{vertical-align:unset;color:#f90e95}[data-v-7aee8cd2] .icon-wrapper svg{fill:currentColor;vertical-align:text-top}.indicator[data-v-7aee8cd2]{left:.25rem;bottom:.25rem;width:1.5rem;height:1.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7aee8cd2","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/app/assets/scss/global/global.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./components/article-levels/Lv9.vue
// module id = 1169
// module chunks = 3 67